import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { PosmCategory } from "../../models/posm-category.model";

@Injectable()
export class PosmCategoryProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<PosmCategory> {
    return this.http
      .get<PosmCategory>(`${this.url}/posm-categories/${id}`)
      .map(response => {
        return new PosmCategory(response);
      })
      .catch(this.handleError)
  }

  getAll(): Observable<PosmCategory[]> {
    return this.http
      .get<PosmCategory[]>(`${this.url}/posm-categories`)
      .map(response => {
        return response.map((posmCategory) => new PosmCategory(posmCategory));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/posm-category/posm-category.ts